const buildClassName = (base: string, options?: { prefix?: string; suffix?: string }): string => {
  const prefix = options?.prefix || '_site-';
  const suffix = options?.suffix || '-page';
  return `${prefix}${base}${suffix}`;
};

export default function (path: string, options?: { prefix?: string; suffix?: string }): string {
  if (path === '/') {
    return buildClassName('index', options);
  }

  const cleanedPath = path.replace(/^\/|\/$/g, '');

  if (cleanedPath.startsWith('person')) {
    return buildClassName('person', options);
  }

  return buildClassName(cleanedPath, options);
};
